<template>
  <a-modal
    title="从Excel导入信息"
    :maskClosable="false"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确认导入'"
    @cancel="handleCancel"
    :footer="null"
  >
    <div class="content">
      <!-- 文件待解析状态或解析header失败 -->
      <template v-if="fileUploadType == '-1' || fileUploadType == '0'">
        <a-steps
          class="steps"
          :current="fileUploadType == '1' ? 1 : 0"
          size="small"
        >
          <a-step title="上传文件" />
          <a-step title="导入完成" />
        </a-steps>

        <div class="file-item">
          <div class="title">1.直接上传</div>
          <div class="desc">-支持文件类型：xls，xlsx</div>
          <div class="desc">
            -支持所有基础字段的导入，一次至多导入500条信息（不符合规则整条信息不予以导入）
          </div>
          <div class="file">
            <div class="import-excel">
              <a-button type="primary" icon="plus">导入学生</a-button>
              <input
                type="file"
                @change="chooseFile"
                accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
            <div class="name" v-if="selectFile && selectFile.name">
              {{ selectFile.name }}
            </div>
            <div class="desc" v-if="fileLoding">
              解析中
              <a-icon type="loading" />
            </div>
          </div>
          <div class="hint" v-if="fileUploadType == '0'">
            <a-icon
              class="icon"
              type="info-circle"
            />文件解析失败，请查看导入规则并更新文件
          </div>
        </div>

        <div class="file-item">
          <div class="title">2.下载模板并填写后上传</div>
          <div class="desc">请先下载「模板」并按照模板填写后再上传</div>
          <a-button class="oper">
            <a
              class="download hover-font-active"
              href="https://static.khsdb.com/student/template/学生模板2025.xlsx"
              download="学生导入模板"
              >下载模板</a
            >
          </a-button>
        </div>
      </template>

      <!-- 文件解析成功 -->
      <template v-else-if="fileUploadType == '1'">
        <div class="table-header-desc">
          共{{ checkFileRes.totalCount }}条信息，其中{{
            checkFileRes.totalCount
          }}条信息可成功导入
        </div>
      </template>

      <!-- 解析失败 -->
      <template v-else-if="fileUploadType == '2'">
        <div class="table-header-desc">
          发现以下{{
            checkFileRes.errorCount
          }}条不符合要求的信息，该Excel将不会被导入
        </div>
        <a-table
          :columns="columns"
          :dataSource="checkFileRes.errorList"
          :pagination="false"
          class="c-table"
          :rowKey="getRowKey"
        >
        </a-table>
      </template>
    </div>
    <div class="submit">
      <!-- 文件不是待解析状态,重新上传 -->
      <a
        class="reset hover-font-active"
        v-if="fileUploadType != '-1'"
        @click="fileUploadType = '-1'"
        >重新上传</a
      >
      <a-button
        type="primary"
        :disabled="fileUploadType != '1'?true:(fileUploadType == '1' && isDisabled)? true :false"
        @click="importFile"
        >确认导入</a-button
      >
    </div>
  </a-modal>
</template>

<script>
import student from "../../../api/student";

const columns = [
  {
    title: "行号",
    dataIndex: "rowId",
  },
  {
    title: "列标题",
    dataIndex: "columnName",
  },
  {
    title: "单元格内容",
    dataIndex: "content",
  },
  {
    title: "错误原因",
    dataIndex: "failReason",
  },
];

export default {
  name: "studentFileModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      columns, //列标识数据
      fileLoding: false, //文件是否解析中
      fileUploadType: "-1", // -1带解析，0表示失败,1表示解析成功
      checkFileRes: {}, //检验错误对象
      selectFile: null, //选择的文件
      isDisabled: false, // 是否禁用
      hide:null
    };
  },
  methods: {
    //提交
    handleSubmit(e) {
      e.preventDefault();
    },

    //导入文件
    importFile() {
      this.isDisabled = true;
      console.log('进入测试了吗')
      this.hide = this.$message.loading('数据导入中请稍等', 0)
      student.importStudent({ fileName: this.selectFile }).then((res1) => {
        setTimeout(this.hide,1)
        this.$message.success("导入成功");
        //刷新
        this.$emit("refreshList");
        this.handleCancel();
      });
    },

    ///选择文件
    chooseFile(e) {
      this.selectFile = e.target.files[0];
      if (!e.target.files[0]) return
      this.fileLoding = true;
      student.checkHeader({ fileName: e.target.files[0] }).then((res) => {
        if (res.data) {
          student
            .checkFileInfo({ fileName: e.target.files[0] })
            .then((res1) => {
              //解析成功或者失败
              this.fileUploadType = res1.data.checkSuccess ? "1" : "2";
              this.checkFileRes = res1.data;
              this.fileLoding = false;
            }).catch(e=>{
              this.fileLoding = false;
            })
        } else {
          //解析header失败
          this.$message.error('文件解析失败')
          this.fileUploadType = "-1";
          this.fileLoding = false;
        }
        //刷新
        e.target.value = "";
      }).catch(e=>{
        this.fileLoding = false;
      })
    },
    getRowKey(record, index) {
      return index;
    },
    //初始化，显示
    init() {
      this.selectFile = null;
      this.fileUploadType = "-1";
      this.visible = true;
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.isDisabled = false;
      setTimeout(this.hide,1)
    },
  },
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.file-item {
  margin-top: 20px;
  padding: 0px 10px;
  > .title {
    font-weight: 500;
    color: $normal-color;
    font-size: 14px;
    position: relative;
    left: -8px;
  }
  > .desc {
    margin-top: 10px;
    color: $normal-color-dark;
    font-size: 14px;
  }
  > .file {
    margin-top: 10px;
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    background: $bg-color;
    .import-excel {
      display: inline-block;
      position: relative;
      display: inline-block;
      width: 130px;
      input {
        position: absolute;
        top: 0px;
        left: 0px;
        width: 110px;
        height: 32px;
        z-index: 999;
        opacity: 0;
      }
      > .download {
        display: inline-block;
        margin-left: 20px;
        color: $primary-color-dark;
        position: relative;
        z-index: 1000;
      }
    }
    > .name {
      width: calc(100% - 100px - 140px);
      display: inline-block;
    }
    > .desc {
      width: 100px;
      display: inline-block;
      color: $primary-color;
    }
  }
  > .hint {
    color: red;
    font-size: 14px;
    margin-top: 6px;
    > .icon {
      display: inline-block;
      margin-right: 6px;
    }
  }
  > .oper {
    margin-top: 10px;
    color: $primary-color-dark;
    border: 1px solid $primary-color-dark;
  }
}
.steps {
  width: 80%;
  margin: 0 auto;
}
.content {
  min-height: calc(100vh - 400px);
  max-height: calc(100vh - 340px);
  overflow: auto;
  padding-bottom: 10px;
}
.submit {
  border-top: 1px solid $border-color;
  padding-top: 10px;
  text-align: right;
  > .reset {
    display: inline-block;
    margin-right: 10px;
  }
}
.table-header-desc {
  font-size: 16px;
  margin-bottom: 20px;
  color: #191919;
}
</style>